import { Components, Theme } from '@mui/material';

export const MuiInputLabelComponentConfiguration: Components<Theme>['MuiInputLabel'] =
  {
    styleOverrides: {
      outlined: ({ theme }) => ({
        color: theme.palette.custom.neutral[700]
      }),
      root: ({ theme }) => ({
        '&.Mui-error:not(.MuiInputLabel-shrink)': {
          color: theme.palette.custom.darkMode[300]
        }
      })
    }
  };
